﻿import { LiveDataSet, LiveDataSetStation, LiveDataSetValue } from "../../API/LiveData/LiveDataSet";
import { DefaultGroupFormatter } from "../../Formatters/DefaultGroupFormatter";
import { WmoToMetarWeatherFormatter } from "../../Formatters/WmoToMetarWeatherFormatter";
import { MainSite } from "../../MainSite";
import { WarningGroup } from "../../Model/WarningGroup";
import { ParameterGroupInfo, ParameterGroupInfoSet } from "../../ParameterGroupInfoSet";
import { StationPopupTableCell } from "./StationPopupTableCell";

export class StationPopup {

    private stationId: string;
    private warningGroup: WarningGroup;

    private popup: JQuery;
    private popupData: JQuery;
    private table: JQuery;

    public mouseIn: boolean = false;
    //private popupTitle: JQuery;

    constructor(private mainSite: MainSite, stationId: string, pixel: any, latestData: LiveDataSet, private openPopups: string[]) {

        // builds an empty popup, and puts it in the right place. NOTE this doesn't actually appear to affect the position of the popup as, at the time
        // of rendering, the popup is empty (and so outerHeight is 0).

        this.stationId = stationId;

        //this.openPopups = [];

        var warningGroup: WarningGroup = this.mainSite.staticDataManager.Schema.WarningGroupSet.WarningGroups[this.mainSite.hashData.WarningGroup];

        if (typeof warningGroup !== 'undefined') {
            this.warningGroup = warningGroup;
        }
            
        var mouseX = pixel[0];
        var mouseY = pixel[1];

        this.popup = $('<div class="midi_mapPage_popup_info"></div>').appendTo('body');

        this.popup.mouseleave(() => {
            this.mouseIn = false;
        });

        this.popup.mouseenter(() => {
            this.mouseIn = true;
        });

        this.refreshData(latestData);

        if (mouseY + this.popup.outerHeight(true) >= ($(window).height()) && mouseX + this.popup.outerWidth(true) >= $(window).width()) {
            this.popup
                .css({
                "top": mouseY - this.popup.outerHeight(true),
                "left": mouseX - this.popup.outerWidth(true)

            })
        }

        else if (mouseY + this.popup.outerHeight(true) >= $(window).height()) {
            this.popup
                .css({
                "top": mouseY - this.popup.outerHeight(true),
                "left": mouseX
            })
        }

        else if (mouseX + this.popup.outerWidth(true) >= $(window).width()) {
            this.popup
                .css({
                "top": mouseY,
                "left": mouseX - this.popup.outerWidth(true)

            })
        }

        else {
            this.popup
                .css({
                "top": mouseY,
                "left": mouseX
            })

        }
    }

    private getParameterGroupValue(station: LiveDataSetStation, parameterGroup: ParameterGroupInfo): any {

        var val: LiveDataSetValue = station.GroupValues[parameterGroup.Id][0];

        if (typeof val == "undefined") {
            return null;
        }
        return val.Value;
    }

    public refreshData(latestData: LiveDataSet): void {
        // redraws the data part of the popup

        if (this.popupData) {
            this.popupData.remove();
        }

        var station: LiveDataSetStation = latestData.Stations[this.stationId];

        this.popupData = $('<div></div>');
        
        $('<div class="midi_mapPage_popup_header"><span>' + station.Station.Label + '</span> - Latest Observations</div>').appendTo(this.popupData);

        this.table = $('<table class="midi_mapPage_popup_table"></table>').appendTo(this.popupData);

        var topRow = $('<tr></tr>').appendTo(this.table);

        var dirBox = new StationPopupTableCell(this.mainSite, topRow, new DefaultGroupFormatter(ParameterGroupInfoSet.WindDirection_deg), station, this.mainSite.selectedWarningRules, this.openPopups);
        var speedBox = new StationPopupTableCell(this.mainSite, topRow, new DefaultGroupFormatter(ParameterGroupInfoSet.WindSpeed_kts), station, this.mainSite.selectedWarningRules, this.openPopups);
        var gustBox = new StationPopupTableCell(this.mainSite, topRow, new DefaultGroupFormatter(ParameterGroupInfoSet.GustSpeed_kts), station, this.mainSite.selectedWarningRules, this.openPopups);

        var middleTopRow = $('<tr></tr>').appendTo(this.table);

        var tempBox = new StationPopupTableCell(this.mainSite, middleTopRow, new DefaultGroupFormatter(ParameterGroupInfoSet.AirTemperature_degC), station, this.mainSite.selectedWarningRules, this.openPopups);
        var dpBox = new StationPopupTableCell(this.mainSite, middleTopRow, new DefaultGroupFormatter(ParameterGroupInfoSet.DewPoint_degC), station, this.mainSite.selectedWarningRules, this.openPopups);
        var qnhBox = new StationPopupTableCell(this.mainSite, middleTopRow, new DefaultGroupFormatter(ParameterGroupInfoSet.QNH_mbar), station, this.mainSite.selectedWarningRules, this.openPopups);

        var middleBottomRow = $('<tr></tr>').appendTo(this.table);

        var visBox = new StationPopupTableCell(this.mainSite, middleBottomRow, new DefaultGroupFormatter(ParameterGroupInfoSet.Visibility_m), station, this.mainSite.selectedWarningRules, this.openPopups);
        var cldAmtBox = new StationPopupTableCell(this.mainSite, middleBottomRow, new DefaultGroupFormatter(ParameterGroupInfoSet.First_CloudCover), station, this.mainSite.selectedWarningRules, this.openPopups);
        var cldHtBox = new StationPopupTableCell(this.mainSite, middleBottomRow, new DefaultGroupFormatter(ParameterGroupInfoSet.First_CloudBaseHeight_ft), station, this.mainSite.selectedWarningRules, this.openPopups);

        var bottomRow = $('<tr></tr>').appendTo(this.table);

        var presentWeatherBox = new StationPopupTableCell(this.mainSite, bottomRow, new WmoToMetarWeatherFormatter(), station, this.mainSite.selectedWarningRules, this.openPopups);
        var hsBox = new StationPopupTableCell(this.mainSite, bottomRow, new DefaultGroupFormatter(ParameterGroupInfoSet.Hs_m), station, this.mainSite.selectedWarningRules, this.openPopups);
        var tzBox = new StationPopupTableCell(this.mainSite, bottomRow, new DefaultGroupFormatter(this.mainSite.selectedRegion.Id == "GOM" ? ParameterGroupInfoSet.Tp_s : ParameterGroupInfoSet.T2_s), station, this.mainSite.selectedWarningRules, this.openPopups);

        var fifthRow = $('<tr></tr>').appendTo(this.table);

        var currentSpeedBox = new StationPopupTableCell(this.mainSite, fifthRow, new DefaultGroupFormatter(ParameterGroupInfoSet.Total_CurrentSpeed_Surface_mps_Mean), station, this.mainSite.selectedWarningRules, this.openPopups);         
        var currentDirectionBox = new StationPopupTableCell(this.mainSite, fifthRow, new DefaultGroupFormatter(ParameterGroupInfoSet.Total_CurrentDirection_Surface_deg_Mean), station, this.mainSite.selectedWarningRules, this.openPopups);         

        this.popupData.appendTo(this.popup);
    }

    public remove(): void {
        this.popup.remove();
    }
}